export class PaymentType {
  // service status
  static ACTIVATION = new PaymentType("ACCOUNT ACTIVATION");

  constructor(name) {
    this.name = name;
  }
}
